<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="12" md="12" class="px-0">
        <v-card class="pa-5" tile>
          <v-data-table
            class="clickable"
            :headers="headers"
            :loading="loading"
            :items="items"
            sort-by="first_name"
            :options.sync="options"
            :items-per-page-items="itemsPerPageItems"
            :server-items-length="totalItems"
            @click:row="showDialog"
          >

            <template v-slot:top>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-folder-search"
                    :label="$t('Search')"
                    single-line
                    hide-details
                    clearable
                    class="ml-3"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="text-right">
                  <v-btn
                    @click="showDialog"
                    color="secondary"
                    class="mr-3"
                    bottom
                  >
                    <v-icon left>mdi-plus</v-icon> {{ $t('Add user') }}
                  </v-btn>
                </v-col>
              </v-row>
            </template>

            <template v-slot:item.status="{ value }">
              <v-icon :color="value ? 'green' : 'grey'">mdi-circle-medium</v-icon>
            </template>

            <template v-slot:item.roles="{ value }">
              {{ Object.values(availableRoles).filter(item => value.includes(item.name)).map(item => item.description).join(', ') }}
            </template>

            <template v-slot:no-data>
              <span>{{ $t('No data available') }}</span>
            </template>

          </v-data-table>

          <ItemDialog ref="itemDialog" @update="fetchItems" />

        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ApiService from '@/services/api.service'
import SessionService from '@/services/session.service'
import ItemDialog from '@/components/UserDialog'
import { mapState } from 'vuex'
import _ from 'lodash'

export default {
  components: {
    ItemDialog,
  },
  data: () => ({
    items: [],
    totalItems: 0,
    loading: true,
    options: { itemsPerPage: 10 },
    search: '',

    itemsPerPageItems: [5, 10, 25, 50],
  }),
  computed: {
    ...mapState('auth', {
      availableRoles: state => state.roles,
    }),
    headers() {
      return [
        { text: this.$t('User name'), value: 'username', align: 'left', sortable: false, width: '15%' },
        { text: this.$t('Name'), value: 'full_name', align: 'left', sortable: false, width: '15%' },
        { text: this.$t('Email'), value: 'email', align: 'left', sortable: false, width: '15%' },
        { text: this.$t('Role'), value: 'roles', align: 'left', sortable: false, width: '15%' },
        { text: this.$t('Status'), value: 'status', align: 'center', sortable: false, width: '10%' },
      ]
    }
  },
  watch: {
    options: {
      handler () {
        this.fetchItems()
      },
      deep: true
    },
    search() {
      this.fetchItems()
    },
  },
  created() {
    this.restoreFilters()
    this.$store.dispatch('session/title', this.$t('Users'))
  },
  methods: {
    showDialog(item = null) {
      this.$refs.itemDialog.showDialog(item ? item.id : null)
    },
    fetchItems: _.debounce(function() {
      this.loading = true
      this.saveFilters()
      ApiService.index('/users', this.options, {
        params: {
          expand: 'roles',
          filter: {
            query: this.search,
            //status: this.userStatus,
          },
        },
      }).then(({ items, total })  => {
        this.items = items
        this.totalItems = total
        this.loading = false
      }).catch(() => {
        this.loading = 'error'
      })
    }, 250),
    saveFilters() {
      SessionService.setItem('filter_users', {
        search: this.search,
        options: this.options,
      })
    },
    restoreFilters() {
      let filters = SessionService.getItem('filter_users')
      if (filters) {
        this.search = filters.search
        this.options = filters.options
      }
    },
  }

}
</script>

<style scoped>

</style>
